module.exports = __webpack_public_path__ + "static/media/4.ec16a612.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/intro/4.png
// module id = 1287
// module chunks = 0